import { Link, useLocation } from '@tanstack/react-router';
import {
  Activity,
  // BarChart2, // Performance — hidden for now
  // Calendar, // Schedules (coming soon) — hidden for now
  Film,
  Layers,
  LayoutDashboard,
  PlayCircle,
  // Scissors, // Video edit (coming soon) — hidden for now
  UserCircle2,
} from 'lucide-react';
import { type ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface NavItem {
  to: string;
  label: string;
  icon: ReactNode;
  /** Match prefix instead of exact path. */
  prefix?: boolean;
}

const NAV_TOP: NavItem[] = [
  { to: '/', label: 'Overview', icon: <LayoutDashboard className="h-4 w-4" /> },
  { to: '/personas', label: 'Personas', icon: <UserCircle2 className="h-4 w-4" />, prefix: true },
  { to: '/content', label: 'Content', icon: <Film className="h-4 w-4" />, prefix: true },
  { to: '/runs', label: 'Runs', icon: <Activity className="h-4 w-4" />, prefix: true },
  // Hidden from the sidebar for now; the /performance route still works.
  // { to: '/performance', label: 'Performance', icon: <BarChart2 className="h-4 w-4" />, prefix: true },
];

const NAV_ACTIONS: NavItem[] = [
  { to: '/triggers/persona', label: 'Trigger persona', icon: <PlayCircle className="h-4 w-4" /> },
  { to: '/triggers/content', label: 'Trigger content', icon: <PlayCircle className="h-4 w-4" /> },
];

// "Coming soon" section — hidden for now.
// const NAV_BOTTOM: NavItem[] = [
//   { to: '/schedules', label: 'Schedules', icon: <Calendar className="h-4 w-4" /> },
//   { to: '/edit', label: 'Video edit', icon: <Scissors className="h-4 w-4" /> },
// ];

export function Sidebar() {
  return (
    <aside className="hidden w-56 shrink-0 border-r border-border bg-card/40 md:flex md:flex-col">
      <div className="flex h-14 items-center gap-2 border-b border-border px-4">
        <Layers className="h-5 w-5 text-foreground" />
        <span className="text-sm font-semibold tracking-tight">Ghost Control</span>
      </div>
      <nav className="flex-1 space-y-6 overflow-y-auto p-3">
        <NavSection items={NAV_TOP} />
        <NavSection title="Trigger" items={NAV_ACTIONS} />
        {/* <NavSection title="Coming soon" items={NAV_BOTTOM} /> */}
      </nav>
      {/* <div className="border-t border-border p-3 text-[11px] text-muted-foreground">
        <p>Operator console — testing phase</p>
      </div> */}
    </aside>
  );
}

function NavSection({ title, items }: { title?: string; items: NavItem[] }) {
  const location = useLocation();
  return (
    <div className="space-y-1">
      {title && (
        <div className="px-2 pb-1 text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">
          {title}
        </div>
      )}
      {items.map((item) => {
        const active = item.prefix
          ? location.pathname === item.to || location.pathname.startsWith(`${item.to}/`)
          : location.pathname === item.to;
        return (
          <Link
            key={item.to}
            to={item.to}
            className={cn(
              'flex items-center gap-2 rounded-md px-3 py-1.5 text-sm transition-colors',
              active
                ? 'bg-accent text-accent-foreground'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground',
            )}
          >
            {item.icon}
            <span>{item.label}</span>
          </Link>
        );
      })}
    </div>
  );
}
